// extracted by mini-css-extract-plugin
export default {"moduleTitle":"ModuleTitle_moduleTitle__jdVQJ"};